<template>
  <div>
    <!-- User Info: Input Fields -->
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
      class="role-edit-tab-information"
    >
      <b-form>
        <b-row>
          <b-col cols="12" md="12">
            <div class="d-flex mb-1">
              <feather-icon icon="UserIcon" size="19" />
              <h4 class="mb-0 ml-50">角色：{{ roleData.name }}</h4>
            </div>
            <b-form-group label="角色名稱" label-for="name">
              <b-form-input
                id="name"
                v-model="roleData.name"
                autofocus
                trim
                placeholder="角色名稱"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <!-- Role Permission -->
       <!-- permissionData.modules" {{ permissionData.modules }} -->
        <!-- .filter((ele) => Object.keys(ele)[0] != 'orders') -->
      <b-card
        no-body
        class="border mt-1"
        v-for="(module, index) in permissionData.modules"
        :key="`module_${index}`"
      > 
        <b-card-header class="p-1">
          <b-card-title class="font-medium-2">
            <!--    <feather-icon icon="LockIcon" size="18" /> -->
            <span class="align-middle ml-50">{{ module.name }}</span>
          </b-card-title>
        </b-card-header>
        <b-table
          striped
          responsive
          class="mb-0"
          :items="module.value.filter((ele) => !['staff_supplier_documents.view_detail',
          'workers.admin', 'user_salaries.admin', 'order_detail.salary_records',
          'order_detail.expense_items'].includes(ele.name))"
          :fields="tableColumns"
        >
          <template #cell(name)="data">
            {{ data.item.remark}}
            <!-- {{ data.item.name }} -->
          </template>
          <template #cell(value)="data">
            <b-form-checkbox v-model="rolePermission" :value="data.item.name" :disabled="data.item.name.indexOf(`setting_roles`) > -1 && roleData.id == 8" />
          </template>
        </b-table>
      </b-card>
      <!-- Action Buttons -->
      <div class="permission-btn-group">
        <b-button
          variant="primary"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          @click="handleSubmit"
        >
          儲存權限
        </b-button>
        <b-button
          variant="outline-secondary"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          type="reset"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          @click="handleSelectAll"
        >
          全選
        </b-button>
        <b-button
          variant="outline-secondary"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          type="reset"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          @click="handleCleanAll"
        >
          清除
        </b-button>
        <b-button
          variant="outline-secondary"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          type="reset"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          @click="handleReset"
        >
          重設
        </b-button>
        <b-button
          variant="outline-secondary"
          type="reset"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          :to="{ name: 'roles-list' }"
        >
          返回
        </b-button>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import {
  BButton,
  BMedia,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BTable,
  BCard,
  BCardHeader,
  BCardTitle,
  BFormCheckbox,
  BOverlay,
} from "bootstrap-vue";
import { avatarText } from "@core/utils/filter";
import vSelect from "vue-select";
import { ref, onMounted, watch } from "@vue/composition-api";
import useRolesList from "../roles-list/useRolesList";
import store from "@/store";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BButton,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    vSelect,
    BOverlay,
    ToastificationContent,
  },
  props: {
    roleData: {
      type: Object,
      required: true,
    },
    permissionData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleSubmit() {
      const data = {
        id: this.roleData.id,
        name: this.roleData.name,
        permission: this.rolePermission,
      };

      this.$swal({
        title: "確認修改權限？",
        showCancelButton: true,
        confirmButtonText: "修改",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          store
            .dispatch("app-role/updateRole", data)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.$emit("refetch-data");
              // 刷新當前用戶權限
              store.dispatch("app/fetchUserInfo").then((response) => {
                let userData = response.data.userData;
                localStorage.setItem("userData", JSON.stringify(userData));
                this.$ability.update(userData.ability);

                // 觸發導航選單權限更新
                this.$nextTick(() => {
                  if (typeof window !== 'undefined' && window.permissionUpdateService) {
                    window.permissionUpdateService.triggerUpdateDelayed('角色權限更新', 200);
                  } else if (typeof window !== 'undefined' && window.updateNavMenuPermissions) {
                    // 向後相容性
                    window.updateNavMenuPermissions();
                  }
                  console.log('✅ 角色權限更新後已觸發導航選單權限更新');
                });

                // 提示用戶權限已更新
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "權限已更新",
                    icon: "CheckIcon",
                    variant: "success",
                    text: "左側選單已自動更新以反映新的權限設置。",
                  },
                });
              });
              // this.$router.replace("/roles/list");
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    handleReset() {
      this.updateRolePermission();
    },
    handleSelectAll() {
      this.rolePermission = [];
      this.rolePermission = [...this.permissionData.all_permissions];
    },
    handleCleanAll() {
      if(this.roleData.id == 8){
         this.rolePermission = this.rolePermission.filter(item => item.indexOf('setting_roles') > -1);
      }else{
      this.rolePermission = [];
      }
    },
  },
  setup(props) {
    const rolePermission = ref([]);
    const loading = ref(false);
    const tableColumns = [
      { key: "name", label: "權限", stickyColumn: true },
      { key: "value", label: "選擇", tdClass: "min-w-50" },
    ];

    const updateRolePermission = () => {
      rolePermission.value = [];
      rolePermission.value = [...props.permissionData.user_permissions];
      /* props.permissionData.forEach((rp) => {
        if (rp.admin) rolePermission.value.push(rp.module + ".admin");
        if (rp.create) rolePermission.value.push(rp.module + ".create");
        if (rp.read) rolePermission.value.push(rp.module + ".read");
        if (rp.update) rolePermission.value.push(rp.module + ".update");
        if (rp.delete) rolePermission.value.push(rp.module + ".delete");
      }); */
    };

    onMounted(() => {
      updateRolePermission();
    });

    return {
      rolePermission,
      updateRolePermission,
      tableColumns,
      loading,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.permission-btn-group {
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  background-color: #fff;
  z-index: 10;
  width: 100%;
  padding: 10px;
}
@media screen and (max-width: 768px) {
  .role-edit-tab-information{
    padding-bottom: 180px;
  }
  .permission-btn-group {
    left: 0;
    right: 0;
    flex-wrap: wrap;      
  }
}
.min-w-50 {
  width: 50%;
}
</style>
